module.exports = __webpack_public_path__ + "static/media/5DPO18.b932e3b9.jpg";